<template>
  <vue-html2pdf :enable-download="true" filename="Sales Report" ref="salesReportPdf" :manual-pagination="true" :pdf-orientation="'portrait'" pdf-format="a4">
    <section slot="pdf-content">
      <div id="pdf-sale-invoice" class="p-8">
        <!-- table titles -->
        <div class="table_title w-full text-center mt-5">
          <h1 class="text-4xl">Overall Sales</h1>
          <p class="font-semibold text-base mt-3">{{ formatDateTime(fromDate) }} - {{ formatDateTime(toDate) }}</p>
        </div>

        <!-- employee Name -->
        <div class="employee_name text-center mt-5">
          <h3>
            Employee Name :- <span>{{ (user && user.username) || '' }}</span>
          </h3>
        </div>

        <!-- data -->
        <div class="data__table my-5">
          <vs-table id="table-loading" class="vs-con-loading__container" noDataText="" stripe :sst="true" :data="[]">
            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>CANNABIS</vs-th>
              <vs-th>NON-CANNABIS</vs-th>
              <vs-th>TOTAL</vs-th>
            </template>

            <template>
              <vs-tr>
                <vs-td>Sales</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.subTotal + reports_data.cannabisData.taxAmt) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.subTotal + reports_data.nonCannabisData.taxAmt) | currencyFilter }}</vs-td>
                <vs-td
                  >${{
                    (reports_data.cannabisData && reports_data.cannabisData.subTotal + reports_data.cannabisData.taxAmt + reports_data.nonCannabisData.subTotal + reports_data.nonCannabisData.taxAmt)
                      | currencyFilter
                  }}</vs-td
                >
              </vs-tr>
              <vs-tr>
                <vs-td>Discount</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.discountAmt) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.discountAmt) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.discountAmt + reports_data.nonCannabisData.discountAmt) | currencyFilter }}</vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-td>Taxes</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.taxAmt) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.taxAmt) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.taxAmt + reports_data.nonCannabisData.taxAmt) | currencyFilter }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>Net Sales</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.netSales) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.netSales) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.netSales + reports_data.nonCannabisData.netSales) | currencyFilter }}</vs-td>
              </vs-tr> -->
              <vs-tr>
                <vs-td>Returns</vs-td>
                <vs-td
                  >${{
                    (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnSubTotal - reports_data.cannabisReturnData.returnDiscount + reports_data.cannabisReturnData.returnTax)
                      | currencyFilter
                  }}</vs-td
                >
                <vs-td
                  >${{
                    (reports_data.nonCannabisReturnData &&
                      reports_data.nonCannabisReturnData.returnSubTotal - reports_data.nonCannabisReturnData.returnDiscount + reports_data.nonCannabisReturnData.returnTax) | currencyFilter
                  }}</vs-td
                >
                <vs-td
                  >${{
                    (reports_data.cannabisReturnData &&
                      reports_data.cannabisReturnData.returnSubTotal -
                        reports_data.cannabisReturnData.returnDiscount +
                        reports_data.cannabisReturnData.returnTax +
                        reports_data.nonCannabisReturnData.returnSubTotal -
                        reports_data.nonCannabisReturnData.returnDiscount +
                        reports_data.nonCannabisReturnData.returnTax) | currencyFilter
                  }}</vs-td
                >
              </vs-tr>
              <!-- <vs-tr>
                <vs-td>Return Discount</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnDiscount) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisReturnData && reports_data.nonCannabisReturnData.returnDiscount) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnDiscount + reports_data.nonCannabisReturnData.returnDiscount) | currencyFilter }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>Return Taxes</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnTax) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisReturnData && reports_data.nonCannabisReturnData.returnTax) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnTax + reports_data.nonCannabisReturnData.returnTax) | currencyFilter }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>Return Sales</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnNetSales) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisReturnData && reports_data.nonCannabisReturnData.returnNetSales) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.cannabisReturnData && reports_data.cannabisReturnData.returnNetSales + reports_data.nonCannabisReturnData.returnNetSales) | currencyFilter }}</vs-td>
              </vs-tr> -->
              <!-- <vs-tr>
                <vs-td>Total Tendered</vs-td>
                <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.totalTendered - reports_data.cannabisReturnData.returnTotalTendered) | currencyFilter }}</vs-td>
                <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.totalTendered - reports_data.nonCannabisReturnData.returnTotalTendered) | currencyFilter }}</vs-td>
                <vs-td
                  >${{
                    (reports_data.cannabisData &&
                      reports_data.cannabisData.totalTendered -
                        reports_data.cannabisReturnData.returnTotalTendered +
                        (reports_data.nonCannabisData.totalTendered - reports_data.nonCannabisReturnData.returnTotalTendered)) | currencyFilter
                  }}</vs-td
                >
              </vs-tr> -->
            </template>
          </vs-table>
        </div>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { mapState } from 'vuex'
import moment from 'moment'
import { paymentMixins } from '@/utils/paymentTypes'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'SalesReportPdf',

  components: {
    VueHtml2pdf
  },

  props: {
    fromDate: {
      type: String,
      default: moment()
        .startOf('day')
        .toString()
    },

    toDate: {
      type: String,
      default: moment()
        .endOf('day')
        .toString()
    },

    user: Object
  },

  mixins: [dateMixins, paymentMixins],

  computed: {
    ...mapState('report', ['reports_data'])
  },
  methods: {
    moment
  },
  async created() {
    this.$nextTick(async () => {
      window.scrollTo(0, 0)
      await this.$refs.salesReportPdf.downloadPdf()
      this.$emit('downloaded')
    })
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style lang="scss">
#pdf-sale-invoice {
  margin-top: 0 !important;
  min-height: 100vh;

  * {
    font-size: 10px;
    h1 {
      font-size: 25px;
    }
  }
  html {
    line-height: unset;
    letter-spacing: unset;
  }
  body {
    color: #000;
  }
  th {
    border: 1px solid;
  }
}
</style>
